<template>
    <breadCrumbs title="Creative Card" main="Bonus UI" title1="Creative Card" />
    <div class="container-fluid">
        <div class="row">
            <card1 />

        </div>
    </div>
</template>
<script>
import card1 from "./card1Page.vue"

export default {
    components: {
        card1,

    }
};
</script>